import {
	optionalDatasetFields,
	requiredDatasetFields,
	datasetCodeValidationErrors,
	datasetVisualValidationErrors,
} from '@/constants/constants';

export const checkDatasetForWarnings = (paymentInfo: PaymentInfo): string[] | null => {
	if (!paymentInfo) {
		return null;
	}

	const {
		provider,
		minimumPaymentDue,
		description,
		customer,
		totalPaymentDue,
		billingPeriod,
		url,
		image,
	} = paymentInfo;
	const type = paymentInfo['@type'];

	const optionalFields = [
		{ type },
		{ providerType: provider ? provider['@type'] : undefined },
		{ providerLegalName: provider ? provider.legalName : undefined },
		{ providerLogo: provider ? provider.logo : undefined },
		{ minimumPaymentDue },
		{ minimumPaymentDueType: minimumPaymentDue ? minimumPaymentDue['@type'] : undefined },
		{ minimumPaymentDuePrice: minimumPaymentDue ? minimumPaymentDue.price : undefined },
		{ minimumPaymentDuePriceCurrency: minimumPaymentDue && minimumPaymentDue.priceCurrency },
		{ totalPaymentDueType: totalPaymentDue ? totalPaymentDue['@type'] : undefined },
		{ description },
		{ customer },
		{ customerType: customer ? customer['@type'] : undefined },
		{ customerName: customer ? customer.name : undefined },
		{ customerAddress: customer ? customer.address : undefined },
		{ customerTelephone: customer ? customer.telephone : undefined },
		{ billingPeriod },
		{ url },
		{ image },
	];

	return optionalFields.map(field => {
		const [key, value] = Object.entries(field)[0];

		return value ? '' : optionalDatasetFields[key];
	});
};

const checkAmountIsNumber = (amount: any): boolean => !isNaN(parseFloat(amount)) && !isNaN(Number(amount));
const checkCodeDateIsValid = (date: any): boolean => {
	// поле необязательное, поэтому если его не ввели, считаем, что все ок
	if (!date) {
		return true;
	}

	const period = new Date(date);

	return period.toString() !== 'Invalid Date';
};

// eslint-disable-next-line no-restricted-globals
export const checkEnterData = (amount: any): boolean => checkAmountIsNumber(amount);

export const validateVisualEditorData = (amount: any): string[] | null => {
	if (!checkEnterData(amount)) {
		return [datasetVisualValidationErrors.incorrectPrice];
	}

	return null;
};

export const validateCodeData = (amount: any, date: any): string[] | null => {
	const errors = [];
	if (!checkEnterData(amount)) {
		errors.push(datasetCodeValidationErrors.incorrectPrice);
	}

	if (!checkCodeDateIsValid(date)) {
		errors.push(datasetCodeValidationErrors.incorrectDate);
	}

	if (errors.length > 0) {
		return errors;
	}

	return null;
};

export const checkDatasetForErrors = (paymentInfo: PaymentInfo): string[] | null => {
	if (!paymentInfo) {
		return ['Вы не ввели JSONLD'];
	}

	const { provider, accountId, totalPaymentDue, paymentDue, billingPeriod } = paymentInfo;
	const context = paymentInfo['@context'];

	const requiresFields = [
		{ context },
		{ provider },
		{ providerName: provider ? provider.name : undefined },
		{ accountId },
		{ totalPaymentDue },
		{ price: totalPaymentDue ? totalPaymentDue.price : undefined },
		{ priceCurrency: totalPaymentDue ? totalPaymentDue.priceCurrency : undefined },
		{ paymentDue },
	];

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const requireErrors = requiresFields.filter(field => (!Object.values(field)[0]));

	let validationErrors;
	if (totalPaymentDue && totalPaymentDue.price) {
		validationErrors = validateCodeData(totalPaymentDue.price, billingPeriod);
	}

	if (requireErrors) {
		let errors: string[] = requireErrors.map(error => {
			const [key] = Object.keys(error);
			return requiredDatasetFields[key];
		});

		if (validationErrors) {
			errors = errors.concat(validationErrors);
		}

		return errors;
	}

	return null;
};
